export default __webpack_public_path__ + "static/media/3b9624f6c11c57ab6f224d1521d02bd01581603125381.6bc33cf6.webp";